import { observer } from 'mobx-react-lite'
import { Box, Icon, IconButton, Typography } from 'shared/ui'
import { type ReviewAccount } from 'entities/Review/model/ReviewAccount'
import styles from './styles.module.scss'

export const PreviewAccountItem = observer(({ account }: { account: ReviewAccount }) => {
  return (
    <div className={styles.previewAccount}>
      <Box padding={'8px'}>
        <Icon icon={account.icon} fontSize={16} />
      </Box>
      <Typography
        ariaLabel={'Account'}
        variant={'button-small'}
        color={'var(--content-primary-primary)'}
        ellipsis
      >
        {account.customName}
      </Typography>
      <Box marginLeft={'auto'}>
        <IconButton
          size={'medium'}
          icon={'arrowRightUp'}
          variant={'icon'}
          color='noop'
          transparentBackground
          iconProps={{ color: 'var(--content-primary-disabled)' }}
          onClick={() => window.open(account.url, '_blank', 'noopener,noreferrer')}
          ariaLabel={'Open link'}
        />
      </Box>
    </div>
  )
})
